<!--
    Component About
    @author Leander Eyer <leander.eyer@elead.ch>
-->

<template>
	<div class="container">
		<div class="content">
			<div class="bar darkText largeText">
				<div class="gridLabel bg-about">{{ model.getDictionary('nav_aboutus')}}</div>
			</div>

			<div class="aboutus-grid">
				<div 
					class='collaborator-tile zoomable'
					v-for="collaborator in collaborators"
					:key="collaborator.seq"
				>
					<div class='collaborator-image'><img :src="collaborator.image.getImageURL('small')"></div>
					<div class='collaborator-text'>{{ collaborator.name }}</div>
				</div>					
			</div>

			<div class="aboutus-text" v-html=" textWithNewLines "></div>

		</div>
	</div>
</template>

<script>

	import { model } from "./../model/Model.js";

	export default {
		data: function() {
			return {
				// expose the model for translations
				model: model,
				// list of Collaborators
				collaborators: model.blockAboutUs
			};
		},

		computed: {
			// Prepare the Timeline Text for display by adding newlines
			textWithNewLines: function() {
				return model.blockText.aboutus.getValue().replace(/\n/g, "<br>");
			}
		}

	};
</script>


<style>
	div.aboutus-grid {
		position: relative;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;
	}

	div.collaborator-tile {
		margin: 0 2rem 2rem 0;
	}

	div.collaborator-image {
		width: 9rem;
		height: 9rem;
		margin: 0 0 1rem 0;
		overflow: hidden;
	}

	div.collaborator-image img {
		object-fit: cover;
		object-position: center;
		filter: grayscale(100%);
		width: 9rem;
		height: 9rem;
	}

	div.collaborator-text {
		font-size: 1rem;
	}

	div.aboutus-text {
		margin: 2rem 0;
		line-height: 2rem;
	}

</style>